<template>
  <div id="app">
    Adminstraion
    {{ this.$route.path }}
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
